var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVibrazione(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9128 3.81055C29.0462 6.54982 32.299 11.6703 32.299 17.0002C32.299 22.3303 29.0462 27.4506 24.9128 30.1899M9.08543 3.81055C4.95221 6.54982 1.69922 11.6703 1.69922 17.0002C1.69922 22.3303 4.95221 27.4506 9.08543 30.1899M22.8029 10.1416C24.4325 11.7655 25.9684 14.518 25.9684 17.0002C25.9684 19.4826 24.4325 22.2349 22.8029 23.8588M11.1956 10.1416C9.5661 11.7655 8.03011 14.518 8.03011 17.0002C8.03011 19.4826 9.5661 22.2349 11.1956 23.8588M18.0546 17.0002C18.0546 17.5829 17.5821 18.0554 16.9994 18.0554C16.4168 18.0554 15.9442 17.5829 15.9442 17.0002C15.9442 16.4175 16.4168 15.945 16.9994 15.945C17.5821 15.945 18.0546 16.4175 18.0546 17.0002Z",
    stroke: "#353A0A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVibrazione);
export default __webpack_public_path__ + "static/media/Vibrazione.cc1528a3e2a89230bfb8f24aeead6eeb.svg";
export { ForwardRef as ReactComponent };